import * as rdd from 'react-device-detect';

export const isMobile = () => rdd.isMobile && !rdd.isTablet;
export const isAndroid = () => rdd.isAndroid;
export const isIOS = () => rdd.isIOS;
